// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2516":"6d564712","6124":"723f7a8e","6312":"4b83a90c","7488":"ab17ea81","8528":"8f6cbe71"}[chunkId] + ".chunk.css";
};